import { tv } from '@change/ds-utils';

export const actionButton = tv({
	base: 'rounded-medium px-4 py-2',
	compoundVariants: [
		{
			// Classes to simulate the primary button from legacy DS
			class:
				'!bg-[#E01A2B] !text-typography-inverse-strong before:!border-none active:!bg-[#B71523] before:active:!border-2 before:active:!border-solid before:active:!border-black hover:!bg-[#B71523] before:hover:!border-2 before:hover:!border-solid before:hover:!border-black',
			actionType: 'shareExperimental',
		},
		{
			class: 'h-[36px] min-w-[104px] [&>*]:text-size-body-small [&>*]:font-bold',
			variant: 'default',
		},
		{
			class: 'h-[56px] flex-1 flex-col gap-0.5 [&>*]:text-size-body-xs [&>*]:leading-4',
			variant: 'square',
		},
	],
	variants: {
		variant: {
			default: '',
			square: '',
		},
		actionType: {
			edit: '',
			link: '',
			view: '',
			share: '',
			shareExperimental: '',
		},
	},
});
